import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { SpaceMapEditComponent } from "./space-map-edit.component";
import { ParkingFilterModule } from "../space-filter/space-filter.module";
import { SpaceMapAssignSpaceComponentModule } from "./space-map-assign-space/space-map-assign-space.module";
import { TranslateModule } from "@ngx-translate/core";
import { BreadcrumbComponentModule } from "../../breadcrumb/breadcrumb.module";
import { SpaceMapComponentModule } from "../space-map/space-map.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ParkingFilterModule,
    SpaceMapAssignSpaceComponentModule,
    TranslateModule,
    BreadcrumbComponentModule,
    SpaceMapComponentModule,
  ],
  declarations: [SpaceMapEditComponent],
  exports: [SpaceMapEditComponent],
})
export class SpaceMapEditComponentModule {}
